export class ShowMore {
  static isOnPage() {
    return $('.js-show-more-container').length !== 0;
  }

  constructor() {
    this.inited = false;
    this.items = [];
    this.init();
    $(window).on('resize', () => this.onResize());
  }

  onResize() {
    this.init();
  }

  onButtonClick(index, $content, $button) {
    const item = this.items[index];
    const itemActive = !item.active;
    const newHeight = itemActive ? item.fullHeight : item.collapsedHeight;

    $content.animate({ height: newHeight }, 'fast');
    $button.toggleClass('slideHide-show', itemActive);
    $button.attr('aria-expanded', String(itemActive));
    $content.attr('aria-hidden', String(!itemActive));

    this.items[index].active = itemActive;
  }

  toggle(index, container) {
    const $container = $(container);
    const $content = $container.find('.js-show-more-content');
    const $button = $container.find('.js-show-more-toggle');

    $button.attr('aria-expanded', 'false');
    $content.css('height', 'auto');
    const fullHeight = $content[0].scrollHeight;

    const rowCount = $container.data('row-count') || 5;
    const lineHeight = parseFloat($content.css('line-height')) || 22;
    const collapsedHeight = rowCount * lineHeight;

    const needsToggle = fullHeight > collapsedHeight;

    this.items[index] = {
      active: false,
      fullHeight,
      collapsedHeight
    };

    if (needsToggle) {
      $content.height(collapsedHeight);
      $content.addClass('ContentSlide');
      $button.parents('.Button--AccordionWrap').addClass('u-display-block');
      $content.attr('aria-hidden', 'true');

      if (!this.inited) {
        $button.on('click', () => this.onButtonClick(index, $content, $button));
      }
    } else {
      $content.removeClass('ContentSlide');
      $button.parents('.Button--AccordionWrap').remove();
    }
  }

  init() {
    $.each($('.js-show-more-container'), (index, container) => this.toggle(index, container));
    this.inited = true;
  }
}
